"use strict";

exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-overlays/~/dom-helpers/transition/isTransform.js
// module id = 2627
// module chunks = 0